import React from "react";

const TargetMarket = ({ value }) => {
  return value?.map((element) => {
    return <tr>{`${element}`} </tr>;
  });
};

export default TargetMarket;
